import { EventDto } from '@diritto/common/event/dtos/event.dto';
import { LinkButton } from 'ui-components/common/LinkButton';
import { ExternalLinkButton } from 'ui-components/common/ExternalLinkButton';
import styled from '@emotion/styled';
import { useTrackingState } from 'contexts/TrackingProvider';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useCallback } from 'react';

interface EventHeaderProps {
  className?: string;
  event: EventDto;
}

export const EventButton = ({ className, event }: EventHeaderProps) => {
  const { tracker } = useTrackingState();

  const { extraInfo } = event;

  const handleTrack = useCallback(() => {
    tracker.track(TrackingEventType.ClickEventButton, { url: extraInfo.button?.url ?? '', eventId: event.id });
  }, [event.id, extraInfo.button?.url, tracker]);

  if (!extraInfo.button) {
    return null;
  }

  if (extraInfo.button.isExternal) {
    return (
      <StyledButtonWrapper className={className}>
        <ExternalLinkButton
          fullWidth
          href={extraInfo.button.url}
          label={extraInfo.button.label}
          onClick={handleTrack}
        />
      </StyledButtonWrapper>
    );
  }

  return (
    <StyledButtonWrapper className={className}>
      <LinkButton fullWidth label={extraInfo.button.label} href={extraInfo.button.url} onClick={handleTrack} />
    </StyledButtonWrapper>
  );
};

const StyledButtonWrapper = styled.div`
  width: 342px;
`;
